import { render, staticRenderFns } from "./shippingMisceallaneous.vue?vue&type=template&id=5b1fb659&scoped=true&"
import script from "./shippingMisceallaneous.vue?vue&type=script&lang=js&"
export * from "./shippingMisceallaneous.vue?vue&type=script&lang=js&"
import style0 from "./shippingMisceallaneous.vue?vue&type=style&index=0&id=5b1fb659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fb659",
  null
  
)

export default component.exports